export default {
  header: {
    title: 'Nagrody',
  },
  content: {
    title: 'Masz {{balance}} punktów',
    description: 'Wydaj {{amount}}, zdobądź {{rewards}} pkt! Dodaj darmowe produkty do koszyka za zebrane punkty.',
    articles: {
      title: 'Zbieraj punkty przy każdym zamówieniu',
      spend_description: 'Za każde wydane {{amount}} otrzymujesz {{rewards}} punktów na swoje konto.',
      redeem_title: 'Wymień swoje punkty',
      redeem_description:
        'Wymieniaj punkty na darmowe smakołyki! Zacznij od {{minSpendingLimit}} pkt, co odpowiada wydaniu {{amount}}',
      discounts_title: 'Odkryj ekskluzywne korzyści',
      discounts_description: 'Odblokuj ekskluzywne oferty i zniżki.',
    },
  },
};
